<button mat-stroked-button class="run-experiment" (click)="onClick()">
    Run Experiment
</button>
